import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const AssetLevelActionsToggle = ({ asset_level, t, handleClick }) => {
  return (
    <Form.Button
      onClick={(e) => {
        e.preventDefault();
        handleClick(asset_level.id);
      }}
      text={t(asset_level.active ? 'actions.deactivate' : 'actions.activate')}
      color={asset_level.active ? 'outline-warning' : 'outline-info'}
      extraClassName={'btn-sm'}
      isLoading={asset_level.isLoading}
    />
  );
};

export default translate()(AssetLevelActionsToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/components/list/actions/AssetLevelActionsToggle.js